import { CategoryData } from './category';
import { PaginatorData } from './paginator';
import { Project, ProjectEvent } from '../../model/project';

declare let isJury: boolean;

export class DataService {

    public categoryData: CategoryData = new CategoryData();
    public paginatedData: PaginatorData = new PaginatorData([]);

    constructor() {
        this.categoryData.data.subscribe((event: ProjectEvent) => {
            switch (event.event) {
                case 'fetch':
                    this.paginatedData.refreshSource(event.data);
                    break;
                // case 'voteSucces':
                //     this.paginatedData.refreshVotes(event.event.args);
                //     break;
            }

        })
    }

    public get categories() {
        return this.categoryData.categories;
    }
    public get countries() {
        return this.categoryData.countries;
    }
    public get country() {
        return this.categoryData.country;
    }

    public vote(year, projId, votes) {
        this.categoryData.updateVote(year, projId, votes);
    }

    public getVote(projId) {
        return this.categoryData.getVote(projId);
    }

    public isJuryUser() {
        if (!(self as any).isJury) return false;
        return isJury;
    }

    public best10Place(id) {
        return this.categoryData.best10.indexOf(id);
    }

    public changeCategory(category: { id: number, name }) {
    }

    public updateProjects() {
        this.categoryData.updateProjects();
    }



}

export const dataService = new DataService();